import { render, staticRenderFns } from "./MenuSimple.vue?vue&type=template&id=94fa8166&"
import script from "./MenuSimple.vue?vue&type=script&lang=js&"
export * from "./MenuSimple.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports